module.exports = __webpack_public_path__ + "img/rate1.1338e0dc.png";